// @ts-nocheck
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export type StatusColor = "success" | "warning" | "danger" | "info" | "neutral";

/* Store Custom Code - Start */
export const statusFontStyles = () => {
    return css`
        font-size: ${x => x.theme.design.typography.size.smallest};
        font-weight: ${x => x.theme.design.typography.weight.bold};
        line-height: ${x => x.theme.design.typography.lineHeight.small};
    `;
};
/* Store Custom Code - End */

export const statusStyles = (color?: StatusColor, offset?: IconOffset) => {
    return css`
        display: flex;
        align-items: center;
        /* Store Removed - padding */
        border-radius: ${pxToRem(4)};

        ${({ theme }) => css`
            color: ${getColor(color)};
            /* Store Removed - background-color */
            /* Store Removed - font-size */
            /* Store Removed - font-weight */
            /* Store Removed - line-height */
            ${statusFontStyles() /* Store Custom Code */}
        `}

        ${IconWrapper} {
            ${iconScalableStyles(pxToRem(8), offset) /* Store Custom Code */}
            overflow: visible;
            height: 0;
            margin: ${pxToRem(0, 6, 0, 0) /* Store Custom Code */};
        }
    `;
};
